import {
  Hidden,
  makeStyles,
  useMediaQuery
} from '@material-ui/core'
import { Button, SWAPSpace, Typography, Chip } from '@yosgo/swap-ui'
import Avatar, { AvatarData } from './Avatar'
import { CGIR, CGIRM, NewsItem } from './NewsBlock'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import HiredMoreModal, { HiredItem } from './HiredMoreModal'
import { CollectCaseGroupItemViewerFromGuess } from '../../../utils/AppRequest'
import { ParseAccountToken } from '../../../utils/HandleToken'

const useStyles = makeStyles({
  displayCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  displayFlexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  displayFlexJustifyStart: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  newsItemContainer: {
    border: '1px solid #ccc',
    backgroundColor: 'white',
    borderRadius: 12,
    boxShadow: '0 8px 40px 0 rgba(0, 0, 0, 0.12)'
  },
  groupIcon: {
    width: 16,
    height: 16,
    objectFit: 'fill',
    borderRadius: '50%'
  },
  newsItemContent: {},
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  descriptionCover: {
    width: '100%',
    height: 80,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundImage: `url(${require('./assets/description_cover.png').default.src})`,
    borderRadius: 8,
    border: '1px solid #ECECEC'
  },
  descriptionContainer: {
    overflow: 'hidden'
  },
  viewMoreCover: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 75%)'
  },
  viewMoreButton: {
    position: 'absolute',
    bottom: 0,
    right: '50%',
    transform: 'translateX(50%)',
    cursor: 'pointer'
  },
  hDivier: {
    height: 12,
    width: 1,
    backgroundColor: '#909090',
    margin: '0 6px'
  },
  hiringContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -4px'
  },
  hiringItem: {
    padding: 8,
    borderRadius: 12,
    border: '1px solid #ECECEC'
  },
  avatarContainer: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: '#ECECEC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  hiredContainer: {
  },
  hiredMoreItem: {
    width: 56,
    height: 56,
    borderRadius: 12,
    backgroundColor: '#E6E9F8',
    cursor: 'pointer'
  },
  iconContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 2
  },
  shareButton: {
    boxShadow: '0px -1px 0px 0px #ECECEC',
    padding: '14px 0',
    cursor: 'pointer',
  },
})

/**
 * homePageCard: 為 true 時，會顯示簡單版本的社團卡片
 */
interface CaseCardComponentProps {
  style?: any,
  data: NewsItem;
  member: { id: string };
  isJoined: boolean,
  homePageCard?: boolean,
  onOpenApplyModal: () => void;
  onOpenJoinModal: () => void;
  onOpenShareModal: () => void;
}
const CaseCardComponent = ({
  style,
  data,
  member,
  isJoined,
  homePageCard,
  onOpenApplyModal,
  onOpenJoinModal,
  onOpenShareModal,
  }: CaseCardComponentProps) => {
  const classes = useStyles()
  const match768 = useMediaQuery('(min-width:768px)')
  const AVATAR_WIDTH = 64
  const GROUP_ID = '2251014c-391e-42e7-91d8-fdc6b3cdce73'

  const [filterHiredItems, setFilterHiredItems] = useState<HiredItem[]>([])
  const [viewAll, setViewAll] = useState(false)
  const [isOpenHiredMoreModal, setIsOpenHiredMoreModal] = useState(false)

  const isApply = data.case_group_item_candidates.some((item) => item.member_id === member.id)
  /*
   * 已經招募的成員需要從 cgir 中的 cgirm 取出。
   * 將其轉換成陣列，用於顯示在下方已招募卡片中。
   */
  const hiredItems = data.cgir.reduce((acc: HiredItem[], cur: CGIR) => {
    const _list: HiredItem[] = cur.cgirm.map((item: CGIRM) => ({
      id: item.member_id,
      role_name: cur.role_name,
      name: item.member.nick_name,
      picture: item.member.picture,
    }))
    return [...acc, ..._list]
  }, [])
  // 招募職位中，已經招募完畢的不顯示
  const filterCGIR = data.cgir.filter((item: CGIR) => item.cgirm.length < +item.quantity_required);
  // 如果所有職位都招募結束，卡片狀態為已招募完畢
  const isAllHired = filterCGIR.length === 0;

  useEffect(() => {
    const el = document.querySelector(`#case_card_${data.id}`)
    if (!el) return

    // 已招募卡片會看畫面的寬度，自動計算要顯示幾個在畫面中
    const calcHiredItems = () => {
      const _width = el.clientWidth - (match768 ? 48 : 32)
      const _count = Math.floor(_width / AVATAR_WIDTH)
      const _filterHiredItems = hiredItems.filter((_: HiredItem, index: number) => index < _count - 1)
      setFilterHiredItems(_filterHiredItems)
    }
    calcHiredItems()

    /*
     * 卡片顯示在畫面上時，要呼叫 API 進行觀看次數的統計
     * threshold 為 0.5，表示當元素顯示在畫面中超過 50% 時，觸發事件
     */
    const triggerEvent = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      entries.forEach(async (item: IntersectionObserverEntry) => {
        if (item.isIntersecting) {
          // 移除監聽
          observer.unobserve(el!)
          // 呼叫統計 API
          await CollectCaseGroupItemViewerFromGuess({ case_group_item_id: data.id })
        }
      })
    }
    const ob = new IntersectionObserver(triggerEvent, { threshold: 0.5 })
    if (el) {
      // 監聽元素
      ob.observe(el)
      window.addEventListener('resize', () => {
        calcHiredItems()
      })
    }
  }, [])

  /*
   * 時間顯示邏輯：
   * 一小時內：x 分鐘前
   * 一天內：x 小時前
   * 一週內：x 天前
   * 一週前：x 年 x 月 x 日
   */
  const createTimeText = (dateTime: string) => {
    const numberDateTime = +dateTime
    const diffHours = dayjs().diff(dayjs(numberDateTime), 'hours')

    if (diffHours === 0) {
      return `${dayjs().diff(numberDateTime, 'minutes')}分鐘前`
    }
    if (diffHours < 24) {
      return `${dayjs().diff(numberDateTime, 'hours')}小時前`
    }
    if (diffHours >= 24 && diffHours < 168) {
      return `${dayjs().diff(numberDateTime, 'days')}天前`
    }
    return dayjs(numberDateTime).format('YYYY年M月D日')
  }

  const handleViewAll = () => {
    if (homePageCard) {
      if (!ParseAccountToken()) {
        window.open(`/public/group/${GROUP_ID}`, '_blank')
      } else {
        window.open(`/member/group/detail/${GROUP_ID}`, '_blank')
      }
    } else {
      setViewAll(true)
    }
  }
  const handleOpenModel = () => {
    if (isJoined) {
      onOpenApplyModal()
    } else {
      onOpenJoinModal()
    }
  }

  return (
    <div id={`case_card_${data.id}`} className={classes.newsItemContainer} style={{ marginBottom: match768 ? 20 : 10, ...style }}>
      <div className={classes.newsItemContent} style={{ padding: match768 ? 24 : 16 }}>
        <div className={classes.headerContainer}>
          <div style={{ width: match768 ? 'calc(100% - 100px)' : '100%' }}>
            <Typography
              variant={match768 ? 'h5' : 'h6'}
              color="black1000"
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}>
                {data.title}
            </Typography>
            <SWAPSpace size={8} />
            <div className={classes.displayFlexJustifyStart} style={{ flexWrap: 'wrap' }}>
              <div className={classes.displayFlexJustifyStart} style={{ marginBottom: 4 }}>
                <img className={classes.groupIcon} src={data.case_group.avatar} alt='' style={{ marginBottom: 2 }} />
                <Typography variant="caption2" color="black800" style={{ marginLeft: 4 }}>{data.case_group.title}</Typography>
              </div>
              <Typography variant="caption2" color="black800" style={{ marginBottom: 4 }}>
                ・
                {createTimeText(data.created_at)}
              </Typography>
              <Typography variant="caption2" color="black800" style={{ marginBottom: 4 }}>
                ・
                為您推廣
              </Typography>
              <div className={classes.displayFlexJustifyStart} style={{ marginBottom: 4 }}>
                <Typography variant="caption2" color="black800">
                  ・
                </Typography>
                <span>
                  {data.is_publish ? icon_public : icon_locker}
                </span>
              </div>
            </div>
            <SWAPSpace size={4} />
            <Typography variant="subtitle" color="secondary800">
              {data.templates.block1 || ''}
            </Typography>
          </div>
          {/* Desktop */}
          <Hidden smDown>
            <div>
              {isAllHired || data.is_completed ? (
                <Chip
                  label={
                    <Typography variant="subtitle" color="black800">
                      已招募完畢
                    </Typography>
                  }
                  outlined
                  variant="neutral"
                  style={{
                    height: 32
                  }}
                />
              ) : (
                isApply ? (
                  <Chip
                    label={
                      <Typography variant="subtitle" color="success800">
                        已報名
                      </Typography>
                    }
                    outlined
                    variant="success"
                    style={{
                      height: 32
                    }}
                  />
                ) : (
                  <Button
                    size="small"
                    onClick={handleOpenModel}
                  >
                    立即報名
                  </Button>
                )
              )
              }
            </div>
          </Hidden>
        </div>
        <SWAPSpace size={match768 ? (data.templates.block2 === null && !homePageCard) ? 16 : 20 : 16} />
        {/* Mobile */}
        <Hidden mdUp>
          <div>
            {isAllHired || data.is_completed ? (
              <Chip
                label={
                  <Typography variant="subtitle" color="black800">
                    已招募完畢
                  </Typography>
                }
                outlined
                variant="neutral"
                style={{
                  width: '100%',
                  height: 40
                }}
              />
            ) : (
              isApply ? (
                <Chip
                  label={
                    <Typography variant="subtitle" color="success800">
                      已報名
                    </Typography>
                  }
                  outlined
                  variant="success"
                  style={{
                    width: '100%',
                    height: 40
                  }}
                />
              ) : (
                <Button
                  size="small"
                  onClick={handleOpenModel}
                  style={{
                    width: '100%',
                    height: 40
                  }}
                >
                  立即報名
                </Button>
              )
            )
            }
          </div>
          <SWAPSpace size={16} />
        </Hidden>
        {data.templates.block2 === null ? (
          <div className={`${classes.descriptionCover} ${classes.displayCenter}`}>
            <div className={classes.displayCenter}>
              {icon_locker}
              <Typography variant="body2" color="black800" style={{ marginLeft: 4 }}>
                您必須為社團成員才能查看案件內容
              </Typography>
            </div>
          </div>
        ) : (
          <div style={{ position: 'relative' }}>
            <div
              className={classes.descriptionContainer}
              style={{
                maxHeight: viewAll ? 'none' : 80,
              }}
              dangerouslySetInnerHTML={{
                __html: data.templates.block2 || '',
              }}
            >
            </div>
            {!viewAll ? (
              <div className={classes.viewMoreCover}>
                <span className={classes.viewMoreButton} onClick={handleViewAll}>
                  <Typography variant="subtitle" color="primary400">
                    查看全部
                  </Typography>
                </span>
              </div>
            ) : null}
          </div>
        )}
        {homePageCard ? null : (
          <>
            <SWAPSpace size={match768 ? data.templates.block2 === null ? 16 : 20 : 16} />
            <div className={classes.displayFlexJustifyStart} style={{ flexWrap: 'wrap' }}>
              <div className={classes.displayFlexJustifyStart}>
            <span className={classes.iconContainer}>
              {icon_calendar}
            </span>
                <Typography variant="caption2" color="black800" style={{ margin: '0 4px' }}>
                  {data.templates.block3}
                </Typography>
                <div className={classes.hDivier} />
              </div>
              <div className={classes.displayFlexJustifyStart}>
            <span className={classes.iconContainer}>
              {icon_pin}
            </span>
                <Typography variant="caption2" color="black800" style={{ margin: '0 4px' }}>
                  {data.templates.block4}
                </Typography>
                <div className={classes.hDivier} />
              </div>
              <div className={classes.displayFlexJustifyStart}>
            <span className={classes.iconContainer}>
              {icon_worktime}
            </span>
                <Typography variant="caption2" color="black800" style={{ margin: '0 4px' }}>
                  {data.templates.block5}
                </Typography>
              </div>
            </div>
            <SWAPSpace size={match768 ? 16 : 12} />
            {filterCGIR.length > 0 ? (
              <>
                <Typography variant="subtitle" color="black1000">
                  招募中
                </Typography>
                <div className={classes.hiringContainer}>
                  {filterCGIR.map((item: CGIR) => {
                    return (
                      <div
                        key={item.id}
                        className={`${classes.hiringItem} ${classes.displayFlexSpaceBetween}`}
                        style={{ width: match768 ? 'calc(50% - 8px)' : '100%', margin: match768 ? '8px 4px 0' : '8px 0 0' }}
                      >
                        <div className={classes.displayFlexJustifyStart}>
                          <div className={classes.avatarContainer}>
                            {icon_avatar}
                          </div>
                          <Typography variant="body2" color="black1000">
                            {item.role_name}
                          </Typography>
                        </div>
                        <Typography variant="caption2" color="black1000" style={{ marginRight: 8 }}>
                          {item.quantity_required}x
                        </Typography>
                      </div>
                    )
                  })}
                </div>
                <SWAPSpace size={match768 ? 20 : 16} />
              </>
            ) : null}
            {filterHiredItems.length > 0 ? (
              <>
                <Typography variant="subtitle" color="black1000">
                  已招募
                </Typography>
                <SWAPSpace size={8} />
                <div className={`${classes.hiredContainer} ${classes.displayFlexJustifyStart}`}>
                  {filterHiredItems.map((item: HiredItem) => {
                    const _data: AvatarData = {
                      id: item.id,
                      tooltipText: `${item.name} | ${item.role_name}`,
                      avatarUrl: item.picture
                    }
                    return (
                      <Avatar key={item.id} data={_data} size={56} />
                    )
                  })}
                  {/* 展示更多的按鈕 */}
                  {hiredItems.length > filterHiredItems.length ? (
                    <div
                      className={`${classes.hiredMoreItem} ${classes.displayCenter}`}
                      onClick={() => setIsOpenHiredMoreModal(true)}
                    >
                      <Typography variant="caption1" color="primary800">
                        +{hiredItems.length - filterHiredItems.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <SWAPSpace size={match768 ? 20 : 16} />
              </>
            ) : null}
            <div className={classes.displayFlexJustifyStart}>
              {icon_eye}
              <Typography variant="body2" color="black800" style={{ marginLeft: 4 }}>
                {data.viewer} 瀏覽
              </Typography>
            </div>
          </>
        )}
      </div>

      {homePageCard ? null : (
        <div
          className={`${classes.shareButton} ${classes.displayCenter}`}
          onClick={onOpenShareModal}
        >
          <div className={classes.displayCenter}>
            {icon_share}
            <Typography variant="subtitle" color="black800" style={{ marginLeft: 4 }}>
              分享
            </Typography>
          </div>
        </div>
      )}

      {/* Modal */}
      <HiredMoreModal
        data={hiredItems}
        open={isOpenHiredMoreModal}
        onClose={() => setIsOpenHiredMoreModal(false)}
      />
    </div>
  )
}

const icon_public = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M11.933 12.0933C11.7597 11.56 11.2597 11.1667 10.6663 11.1667H9.99967V9.16668C9.99967 8.98987 9.92944 8.8203 9.80441 8.69527C9.67939 8.57025 9.50982 8.50001 9.33301 8.50001H5.33301V7.16668H6.66634C6.84315 7.16668 7.01272 7.09644 7.13775 6.97141C7.26277 6.84639 7.33301 6.67682 7.33301 6.50001V5.16668H8.66634C9.01996 5.16668 9.3591 5.0262 9.60915 4.77615C9.8592 4.5261 9.99967 4.18697 9.99967 3.83334V3.56001C11.953 4.34668 13.333 6.26001 13.333 8.50001C13.333 9.88668 12.7997 11.1467 11.933 12.0933ZM7.33301 13.7867C4.69967 13.46 2.66634 11.22 2.66634 8.50001C2.66634 8.08668 2.71967 7.68668 2.80634 7.30668L5.99967 10.5V11.1667C5.99967 11.5203 6.14015 11.8594 6.3902 12.1095C6.64025 12.3595 6.97939 12.5 7.33301 12.5M7.99967 1.83334C7.1242 1.83334 6.25729 2.00578 5.44845 2.34081C4.63961 2.67584 3.90469 3.16691 3.28563 3.78596C2.03539 5.03621 1.33301 6.7319 1.33301 8.50001C1.33301 10.2681 2.03539 11.9638 3.28563 13.2141C3.90469 13.8331 4.63961 14.3242 5.44845 14.6592C6.25729 14.9942 7.1242 15.1667 7.99967 15.1667C9.76779 15.1667 11.4635 14.4643 12.7137 13.2141C13.964 11.9638 14.6663 10.2681 14.6663 8.50001C14.6663 7.62453 14.4939 6.75762 14.1589 5.94879C13.8238 5.13995 13.3328 4.40502 12.7137 3.78596C12.0947 3.16691 11.3597 2.67584 10.5509 2.34081C9.74206 2.00578 8.87515 1.83334 7.99967 1.83334Z" fill="#909090"/>
  </svg>
)

const icon_locker = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g transform="translate(0.6665 0.16669)">
      <path d="M7.99984 11.8334C7.25984 11.8334 6.6665 11.2334 6.6665 10.5C6.6665 9.76002 7.25984 9.16669 7.99984 9.16669C8.35346 9.16669 8.6926 9.30716 8.94265 9.55721C9.19269 9.80726 9.33317 10.1464 9.33317 10.5C9.33317 10.8536 9.19269 11.1928 8.94265 11.4428C8.6926 11.6929 8.35346 11.8334 7.99984 11.8334ZM11.9998 13.8334V7.16669H3.99984V13.8334H11.9998ZM11.9998 5.83335C12.3535 5.83335 12.6926 5.97383 12.9426 6.22388C13.1927 6.47393 13.3332 6.81307 13.3332 7.16669V13.8334C13.3332 14.187 13.1927 14.5261 12.9426 14.7762C12.6926 15.0262 12.3535 15.1667 11.9998 15.1667H3.99984C3.25984 15.1667 2.6665 14.5667 2.6665 13.8334V7.16669C2.6665 6.42669 3.25984 5.83335 3.99984 5.83335H4.6665V4.50002C4.6665 3.61597 5.01769 2.76812 5.64281 2.143C6.26794 1.51788 7.11578 1.16669 7.99984 1.16669C8.43758 1.16669 8.87103 1.25291 9.27545 1.42042C9.67987 1.58794 10.0473 1.83347 10.3569 2.143C10.6664 2.45253 10.9119 2.81999 11.0794 3.22441C11.247 3.62883 11.3332 4.06228 11.3332 4.50002V5.83335H11.9998ZM7.99984 2.50002C7.4694 2.50002 6.9607 2.71073 6.58562 3.08581C6.21055 3.46088 5.99984 3.96959 5.99984 4.50002V5.83335H9.99984V4.50002C9.99984 3.96959 9.78912 3.46088 9.41405 3.08581C9.03898 2.71073 8.53027 2.50002 7.99984 2.50002Z" fill="#909090"/>
    </g>
  </svg>
)

const icon_calendar = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M12.6667 2.66634H12V1.33301H10.6667V2.66634H5.33333V1.33301H4V2.66634H3.33333C2.59333 2.66634 2 3.26634 2 3.99967V13.333C2 14.0663 2.59333 14.6663 3.33333 14.6663H12.6667C13.4 14.6663 14 14.0663 14 13.333V3.99967C14 3.26634 13.4 2.66634 12.6667 2.66634ZM12.6667 13.333H3.33333V6.66634H12.6667V13.333ZM12.6667 5.33301H3.33333V3.99967H12.6667V5.33301ZM4.66667 7.99967H8V11.333H4.66667V7.99967Z" fill="#909090"/>
  </svg>
)

const icon_pin = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M7.99992 4.33301C8.44195 4.33301 8.86587 4.5086 9.17843 4.82116C9.49099 5.13372 9.66658 5.55765 9.66658 5.99967C9.66658 6.21854 9.62348 6.43527 9.53972 6.63748C9.45596 6.83969 9.33319 7.02342 9.17843 7.17819C9.02367 7.33295 8.83993 7.45572 8.63772 7.53947C8.43551 7.62323 8.21879 7.66634 7.99992 7.66634C7.55789 7.66634 7.13397 7.49075 6.82141 7.17819C6.50885 6.86562 6.33325 6.4417 6.33325 5.99967C6.33325 5.55765 6.50885 5.13372 6.82141 4.82116C7.13397 4.5086 7.55789 4.33301 7.99992 4.33301ZM7.99992 1.33301C9.2376 1.33301 10.4246 1.82467 11.2997 2.69984C12.1749 3.57501 12.6666 4.762 12.6666 5.99967C12.6666 9.49967 7.99992 14.6663 7.99992 14.6663C7.99992 14.6663 3.33325 9.49967 3.33325 5.99967C3.33325 4.762 3.82492 3.57501 4.70009 2.69984C5.57526 1.82467 6.76224 1.33301 7.99992 1.33301ZM7.99992 2.66634C7.11586 2.66634 6.26802 3.01753 5.6429 3.64265C5.01777 4.26777 4.66659 5.11562 4.66659 5.99967C4.66659 6.66634 4.66659 7.99967 7.99992 12.473C11.3333 7.99967 11.3333 6.66634 11.3333 5.99967C11.3333 5.11562 10.9821 4.26777 10.3569 3.64265C9.73182 3.01753 8.88397 2.66634 7.99992 2.66634Z" fill="#909090"/>
  </svg>
)

const icon_worktime = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_101_1139)">
      <path d="M14.0001 7.4065V4.6665C14.0004 4.31441 13.8614 3.97649 13.6134 3.7265C13.4925 3.59758 13.3456 3.49584 13.1824 3.42803C13.0192 3.36022 12.8434 3.32788 12.6667 3.33317H10.0001V1.99984C10.005 1.82383 9.9731 1.64875 9.90652 1.48575C9.83995 1.32275 9.74012 1.17542 9.61342 1.05317C9.49116 0.926463 9.34383 0.826636 9.18084 0.76006C9.01784 0.693483 8.84275 0.66162 8.66675 0.666503H6.00008C5.82408 0.66162 5.64899 0.693483 5.48599 0.76006C5.323 0.826636 5.17567 0.926463 5.05342 1.05317C4.92671 1.17542 4.82688 1.32275 4.76031 1.48575C4.69373 1.64875 4.66187 1.82383 4.66675 1.99984V3.33317H2.00008C1.82342 3.32788 1.64766 3.36022 1.48445 3.42803C1.32124 3.49584 1.17431 3.59758 1.05342 3.7265C0.805468 3.97649 0.666467 4.31441 0.666748 4.6665V11.9998C0.666467 12.3519 0.805468 12.6898 1.05342 12.9398C1.17431 13.0688 1.32124 13.1705 1.48445 13.2383C1.64766 13.3061 1.82342 13.3385 2.00008 13.3332H6.84008C7.20652 13.8683 7.68049 14.3213 8.23176 14.663C8.78303 15.0048 9.39948 15.2278 10.0418 15.318C10.6841 15.4082 11.3382 15.3635 11.9622 15.1868C12.5863 15.01 13.1666 14.7052 13.6663 14.2916C14.1659 13.878 14.5739 13.3648 14.8641 12.7848C15.1543 12.2047 15.3204 11.5705 15.3518 10.9227C15.3832 10.2748 15.2792 9.62754 15.0465 9.02213C14.8138 8.41672 14.4574 7.86647 14.0001 7.4065ZM6.00008 1.99984H8.66675V3.33317H6.00008M2.00008 11.9998V4.6665H12.6667V6.45317C12.0431 6.15217 11.3592 5.99714 10.6667 5.99984C9.42907 5.99984 8.24209 6.4915 7.36692 7.36667C6.49175 8.24184 6.00008 9.42883 6.00008 10.6665C5.99884 11.118 6.06398 11.5673 6.19342 11.9998M12.6667 13.3332C12.0898 13.7659 11.388 13.9998 10.6667 13.9998C9.94551 13.9998 9.24374 13.7659 8.66675 13.3332C8.25043 13.0249 7.91272 12.6227 7.68104 12.1594C7.44937 11.696 7.33026 11.1845 7.33342 10.6665C7.33342 9.78245 7.68461 8.9346 8.30973 8.30948C8.93485 7.68436 9.78269 7.33317 10.6667 7.33317C11.3885 7.33025 12.0911 7.56447 12.6667 7.99984C13.0807 8.31033 13.4167 8.71294 13.6482 9.17579C13.8796 9.63864 14.0001 10.149 14.0001 10.6665C14.0001 11.184 13.8796 11.6944 13.6482 12.1572C13.4167 12.6201 13.0807 13.0227 12.6667 13.3332ZM10.0001 8.6665H11.0001V10.5465L12.6267 11.4865L12.1267 12.3532L10.0001 11.1265V8.6665Z" fill="#909090"/>
    </g>
    <defs>
      <clipPath id="clip0_101_1139">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)

const icon_avatar = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M7.99992 12.8C6.33325 12.8 4.85992 11.9466 3.99992 10.6666C4.01992 9.33331 6.66659 8.59998 7.99992 8.59998C9.33325 8.59998 11.9799 9.33331 11.9999 10.6666C11.1399 11.9466 9.66659 12.8 7.99992 12.8ZM7.99992 3.33331C8.53035 3.33331 9.03906 3.54403 9.41413 3.9191C9.78921 4.29417 9.99992 4.80288 9.99992 5.33331C9.99992 5.86375 9.78921 6.37245 9.41413 6.74753C9.03906 7.1226 8.53035 7.33331 7.99992 7.33331C7.46949 7.33331 6.96078 7.1226 6.5857 6.74753C6.21063 6.37245 5.99992 5.86375 5.99992 5.33331C5.99992 4.80288 6.21063 4.29417 6.5857 3.9191C6.96078 3.54403 7.46949 3.33331 7.99992 3.33331ZM7.99992 1.33331C7.12444 1.33331 6.25753 1.50575 5.4487 1.84078C4.63986 2.17581 3.90493 2.66688 3.28587 3.28593C2.03563 4.53618 1.33325 6.23187 1.33325 7.99998C1.33325 9.76809 2.03563 11.4638 3.28587 12.714C3.90493 13.3331 4.63986 13.8241 5.4487 14.1592C6.25753 14.4942 7.12444 14.6666 7.99992 14.6666C9.76803 14.6666 11.4637 13.9643 12.714 12.714C13.9642 11.4638 14.6666 9.76809 14.6666 7.99998C14.6666 4.31331 11.6666 1.33331 7.99992 1.33331Z" fill="#CCCCCC"/>
  </svg>
)

const icon_eye = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8.00008 6C8.53051 6 9.03922 6.21071 9.41429 6.58579C9.78937 6.96086 10.0001 7.46957 10.0001 8C10.0001 8.53043 9.78937 9.03914 9.41429 9.41421C9.03922 9.78929 8.53051 10 8.00008 10C7.46965 10 6.96094 9.78929 6.58587 9.41421C6.21079 9.03914 6.00008 8.53043 6.00008 8C6.00008 7.46957 6.21079 6.96086 6.58587 6.58579C6.96094 6.21071 7.46965 6 8.00008 6ZM8.00008 3C11.3334 3 14.1801 5.07333 15.3334 8C14.1801 10.9267 11.3334 13 8.00008 13C4.66675 13 1.82008 10.9267 0.666748 8C1.82008 5.07333 4.66675 3 8.00008 3ZM2.12008 8C3.22008 10.24 5.49341 11.6667 8.00008 11.6667C10.5067 11.6667 12.7801 10.24 13.8801 8C12.7801 5.76 10.5067 4.33333 8.00008 4.33333C5.49341 4.33333 3.22008 5.76 2.12008 8Z" fill="#909090"/>
  </svg>
)

const icon_share = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M13.3335 4.16658L12.1502 5.34992L10.8252 4.02492V13.3333H9.17516V4.02492L7.85016 5.34992L6.66683 4.16658L10.0002 0.833252L13.3335 4.16658ZM16.6668 8.33325V17.4999C16.6668 18.4166 15.9168 19.1666 15.0002 19.1666H5.00016C4.07516 19.1666 3.3335 18.4166 3.3335 17.4999V8.33325C3.3335 7.40825 4.07516 6.66658 5.00016 6.66658H7.50016V8.33325H5.00016V17.4999H15.0002V8.33325H12.5002V6.66658H15.0002C15.9168 6.66658 16.6668 7.40825 16.6668 8.33325Z" fill="#4B4B4B"/>
  </svg>
)
export default CaseCardComponent
